"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCXColumnsOrSentencesRun = exports.HTMLColumnsOrSentencesRun = exports.HTMLColumnsOrSentencesRunCSS = void 0;
const react_1 = __importDefault(require("react"));
const std = __importStar(require("../../law/std"));
const util_1 = require("../../util");
const common_1 = require("../common");
const component_1 = require("../common/docx/component");
const tags_1 = require("../common/docx/tags");
const TextBoxRun_1 = __importDefault(require("../common/docx/TextBoxRun"));
const html_1 = require("../common/html");
const sentenceChildrenRun_1 = require("./sentenceChildrenRun");
const table_1 = require("./table");
exports.HTMLColumnsOrSentencesRunCSS = `
`;
exports.HTMLColumnsOrSentencesRun = (0, html_1.wrapHTMLComponent)("HTMLColumnsOrSentencesRun", ((props) => {
    const { els, htmlOptions } = props;
    const runs = [];
    for (let i = 0; i < els.length; i++) {
        const el = els[i];
        if (std.isSentence(el)) {
            runs.push(react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: el.children, htmlOptions }));
        }
        else if (std.isColumn(el)) {
            if (i !== 0) {
                runs.push(react_1.default.createElement(html_1.HTMLMarginSpan, { className: "lawtext-column-margin" }));
            }
            const subruns = [];
            for (let j = 0; j < el.children.length; j++) {
                const subel = el.children[j];
                subruns.push(react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: subel.children, htmlOptions }));
            }
            runs.push(react_1.default.createElement("span", { className: "lawtext-column", ...(0, html_1.elProps)(el, htmlOptions) }, (0, common_1.withKey)(subruns)));
        }
        else if (std.isTable(el)) {
            runs.push((react_1.default.createElement("span", { style: { display: "inline-block" }, ...(0, html_1.elProps)(el, htmlOptions) },
                react_1.default.createElement(table_1.HTMLTable, { el: el, indent: 0, htmlOptions }))));
        }
        else {
            (0, util_1.assertNever)(el);
        }
    }
    return react_1.default.createElement(react_1.default.Fragment, null, (0, common_1.withKey)(runs));
}));
exports.DOCXColumnsOrSentencesRun = (0, component_1.wrapDOCXComponent)("DOCXColumnsOrSentencesRun", ((props) => {
    const { els, docxOptions } = props;
    const runs = [];
    for (let i = 0; i < els.length; i++) {
        const el = els[i];
        if (std.isSentence(el)) {
            runs.push(react_1.default.createElement(sentenceChildrenRun_1.DOCXSentenceChildrenRun, { els: el.children, docxOptions }));
        }
        else if (std.isColumn(el)) {
            if (i !== 0) {
                runs.push((react_1.default.createElement(tags_1.w.r, null,
                    react_1.default.createElement(tags_1.w.t, null, component_1.DOCXMargin))));
            }
            for (let j = 0; j < el.children.length; j++) {
                const subel = el.children[j];
                runs.push(react_1.default.createElement(sentenceChildrenRun_1.DOCXSentenceChildrenRun, { els: subel.children, docxOptions }));
            }
        }
        else if (std.isTable(el)) {
            runs.push((react_1.default.createElement(TextBoxRun_1.default, { id: 10000 + el.id, name: `Table${el.id}` },
                react_1.default.createElement(table_1.DOCXTable, { el: el, indent: 0, docxOptions }))));
        }
        else {
            (0, util_1.assertNever)(el);
        }
    }
    return react_1.default.createElement(react_1.default.Fragment, null, (0, common_1.withKey)(runs));
}));
//# sourceMappingURL=columnsOrSentencesRun.js.map